import { getInstructorCategory, INSTRUCTORS, type InstructorCategory } from "@/lib/instructorMapping";

/** Display name for the instructor backing a topic / course. */
export function getInstructorDisplayForCourse(courseName?: string | null): string {
  const cat = getInstructorCategory(courseName);
  if (cat === "finance") return "Aelyra Solari";
  if (cat === "economics") return "Caelion Veyr";
  return "Headmaster Vaelor";
}

export function getPillarForCourse(courseName?: string | null): "Finance" | "Economics" | "Entrepreneurship & Wealth" {
  const cat = getInstructorCategory(courseName);
  if (cat === "finance") return "Finance";
  if (cat === "economics") return "Economics";
  return "Entrepreneurship & Wealth";
}

export const PILLAR_ORDER: Array<"Finance" | "Economics" | "Entrepreneurship & Wealth"> = [
  "Finance",
  "Economics",
  "Entrepreneurship & Wealth",
];

/** Practical Money Skills list shown in the Skills Tracker. */
export const PRACTICAL_SKILLS: Array<{ name: string; topic: string }> = [
  { name: "Budgeting Basics", topic: "Saving & Budgeting" },
  { name: "Saving Goals", topic: "Saving & Budgeting" },
  { name: "Banking Basics", topic: "Banking & Cash Management" },
  { name: "Credit Card Basics", topic: "Credit & Debt Management" },
  { name: "Debt & Interest", topic: "Credit & Debt Management" },
  { name: "Investing Basics", topic: "Investing Fundamentals" },
  { name: "Taxes & Paychecks", topic: "Taxes & Paychecks" },
  { name: "Scam Awareness", topic: "Scams & Fraud" },
  { name: "Career & Income", topic: "Career & Income" },
  { name: "Entrepreneurship", topic: "Entrepreneurship" },
  { name: "Real Estate Basics", topic: "Real Estate" },
  { name: "Insurance Protection", topic: "Insurance & Protection" },
];

export type PillarSummary = {
  pillar: "Finance" | "Economics" | "Entrepreneurship & Wealth";
  instructor: string;
  category: InstructorCategory;
};

export const PILLAR_META: Record<"Finance" | "Economics" | "Entrepreneurship & Wealth", PillarSummary> = {
  Finance: { pillar: "Finance", instructor: "Aelyra Solari", category: "finance" },
  Economics: { pillar: "Economics", instructor: "Caelion Veyr", category: "economics" },
  "Entrepreneurship & Wealth": { pillar: "Entrepreneurship & Wealth", instructor: "Headmaster Vaelor", category: "entrepreneurship" },
};

export { INSTRUCTORS };